var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 100,
    viewBox: "0 0 48 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7842 99.65H16.6742V87.55C10.5876 86.9633 5.49089 85.4967 1.38422 83.15V68.96C7.69089 73.5067 14.5842 75.78 22.0642 75.78C25.4376 75.78 28.1509 74.9733 30.2042 73.36C32.2576 71.6733 33.2842 69.4367 33.2842 66.65C33.2842 64.3033 32.3309 62.36 30.4242 60.82C28.4442 59.2067 26.6476 58.07 25.0342 57.41C23.4209 56.6767 21.8809 55.98 20.4142 55.32C13.6676 52.5333 8.71755 49.49 5.56422 46.19C2.41089 42.89 0.834219 38.49 0.834219 32.99C0.834219 27.4167 2.74089 22.7967 6.55422 19.13C10.3676 15.4633 15.5376 13.2633 22.0642 12.53V0.429993H33.2842V12.75C37.5376 13.3367 41.2409 14.4 44.3942 15.94V29.36C38.8942 26.06 33.0276 24.41 26.7942 24.41C23.3476 24.41 20.6342 25.18 18.6542 26.72C16.7476 28.26 15.7942 30.24 15.7942 32.66C15.7942 35.3 17.1509 37.5 19.8642 39.26C21.9909 40.7267 24.7042 42.23 28.0042 43.77C31.3776 45.2367 33.9809 46.4833 35.8142 47.51C37.6476 48.5367 39.5909 49.8933 41.6442 51.58C45.8242 55.0267 47.9142 59.7567 47.9142 65.77C47.9142 71.7833 46.0809 76.6967 42.4142 80.51C38.8209 84.25 33.9442 86.56 27.7842 87.44V99.65Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomeIcon);
export default __webpack_public_path__ + "static/media/IncomeIcon.6e630d6138ed0111f9a24acc7180a67d.svg";
export { ForwardRef as ReactComponent };